<template>
  <!-- <div class="back-top common-icon" v-show='isShow.value'></div> -->
  <div class="back-top" v-show='value' @click="backToTopFn"></div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  export default {
    //props: ['isShow']
    data(){
      return {
        value: false,
        scrollToptimer: null
      }
    },
    computed: {
      ...mapState(['winH'])
    },
    created: function(){
      this.GET_WINH();
    },
    mounted: function(){
      this.handelScrollBackTop();
    },
    methods: {
      ...mapActions(['GET_WINH']),
      backToTopFn: function(){
        let that = this;
        that.scrollToptimer = setInterval(function(){
          let top = document.documentElement.scrollTop + document.body.scrollTop;
          let speed = top/4;
          top -= speed;
          document.documentElement.scrollTop = document.body.scrollTop = top;
          if (top == 0) {
            clearInterval(that.scrollToptimer);
          }
        }, 30)
      },
      handelScrollBackTop: function(){
        let that = this;
        window.addEventListener('scroll', that.scrollFn)
      },
      scrollFn: function(e){
        let that = this;
        var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
        if (scrollTop > that.winH) {
          that.value = true;
        } else {
          that.value = false;
        }
      }
    },
    destroyed: function(){
      let that = this;
      if (that.scrollToptimer) {
        clearInterval(that.scrollToptimer);
      }
      window.removeEventListener('scroll', that.scrollFn);
    }
  }
</script>
<style scoped>
  .back-top {
      position: fixed;
      cursor: pointer;
      bottom: 306px;
      right: 10px;
      width: 50px;
      height: 50px;
      z-index: 10;
      background: url('/static/images/backTop.png') no-repeat center;
      background-size:50px;
  }
  .back-top:hover {
    background: url('/static/images/backTop_hover.png') no-repeat center;
  }
</style>


// WEBPACK FOOTER //
// src/components/common/BackTop.vue